// 导入组件
import Vue from 'vue';
// 配置路由
import Router from 'vue-router';
// 1.引入组件
import login from '@/views/login'; //登录
import index from '@/views/index'; //首页
import tree from '@/views/Tree';
import itemName from '@/views/ItemName';
import video from '@/views/Video';
import order from '@/views/Order';
import leaveword from '@/views/Leaveword';
import config from '@/views/Config';
import userInfo from '@/views/UserInfo';
import userLog from '@/views/UserLog';
import home from '@/views/website/Home';
import item from '@/views/Item';

Vue.use(Router);


// 2.配置路由
const routes = [
  /*默认跳转路由*/
  // {path: '*', redirect: '/login'},
  { path: '/', name: 'Login', component: login },
  { path: '/home', name: '网站首页', hidden: true, component: home },
  { path: '/login', name: '登录', hidden: true, component: login },
  {
    path: '/index', name: '首页', iconCls: 'el-icon-tickets', hidden: true, component: index,
    children: [
      { path: '/tree', name: '产品名录管理', component: tree, meta: { requireAuth: true } },
      { path: '/item', name: '产品管理', component: item, meta: { requireAuth: true } },
      { path: '/itemName', name: '产品名称管理', component: itemName, meta: { requireAuth: true } },
      { path: '/video', name: '视频管理', component: video, meta: { requireAuth: true } },
      { path: '/order', name: '订单管理', component: order, meta: { requireAuth: true } },
      { path: '/leaveword', name: '留言管理', component: leaveword, meta: { requireAuth: true } },
      { path: '/userInfo', name: '用户管理', component: userInfo, meta: { requireAuth: true } },
      { path: '/userLog', name: '用户日志管理', component: userLog, meta: { requireAuth: true } },
      { path: '/config', name: '网站配置', component: config, meta: { requireAuth: true } },
    ]
  }
];

// 3.实例化VueRouter  注意：名字
const router = new Router({
  mode: 'history',   //hash模式改为history
  base: '/saic-admin/',
  routes // （缩写）相当于 routes: routes
});


// 4.导出路由  <router-view></router-view> 放在 App.vue
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js